import { Box, Flex as FlexBase } from "@rebass/grid";
import { Card as CardBase } from "@rentiohq/web-shared/dist/components";
import styled, { borderRadius, spacing } from "@rentiohq/web-theme";

export const ContractCard = styled(Box)`
  border-radius: ${borderRadius("base")};
  background: ${({ theme }) => theme.colors.neutral0};
  margin-bottom: ${spacing("loose")};
  overflow: hidden;
  box-shadow:
    rgba(95, 95, 95, 0.1) 0px 0px 0px 1px,
    rgba(95, 95, 95, 0.15) 0px 1px 3px 0px;
`;

export const Card = styled(CardBase)`
  border-radius: ${borderRadius("base")};
  border: 0.719px solid ${({ theme }) => theme.colors.neutral30};
  background: ${({ theme }) => theme.colors.neutral0};
  box-shadow: 0 0.719px 1.438px 0 rgba(0, 0, 0, 0.05);
  margin-top: 0 !important;
`;

export const Flex = styled(FlexBase)`
  padding: ${spacing("base")};
  background: ${({ theme }) => theme.colors.neutral10};
  gap: ${spacing("base")};
`;
